/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { connect } from '@airglow/store-redux';
import {
  updateValidationConfig
} from '../actions';
import { manageValidationPluginsMode } from '../data/prefabs';
import {
  selectAllViewValidators,
  selectEnabledViewValidators,
  selectModeSettings,
  selectValidationPluginsGrouped
} from '../selectors/manage.validation.plugin.selectors';
import ManageValidation from '../../ui/settings-validation';

const mapState = state => ({
  enabledViewValidators: selectEnabledViewValidators(state),
  mode: manageValidationPluginsMode.value(state),
  plugins: selectValidationPluginsGrouped(state),
  settings: selectModeSettings(state),
  viewValidators: selectAllViewValidators(state)
});

const mapHandlers = dispatch => ({
  onMode: v => dispatch(manageValidationPluginsMode.changeAction(v)),
  onChangeArguments: (namespace, value) => dispatch(updateValidationConfig({
    namespace,
    setting: 'arguments',
    value
  })),
  onSelectLevel: (namespace, value) => dispatch(updateValidationConfig({
    namespace,
    setting: 'level',
    value
  }))
});

export default connect(mapState, mapHandlers)(ManageValidation);
